// extracted by mini-css-extract-plugin
export default {"Pic":"meeting_Pic__jdD5w"};